export default __webpack_public_path__ + "static/media/ic_menu_equipment.b131e369.svg";